module.exports = ".ng-valid[required], .ng-valid.required {\r\n  border-left: 5px solid rgb(66,169,72); /* green */\r\n}\r\n\r\n.ng-invalid:not(form) {\r\n  border-left: 5px solid rgb(211,18,69); /* red */\r\n}\r\n\r\nbutton:disabled, button.close:disabled {\r\n  opacity: 0.4;\r\n  background: gray;\r\n  cursor: default;\r\n}\r\n\r\n.alert {\r\n    padding: 0.25rem 1.00rem;\r\n    height: -webkit-fit-content;\r\n    height: -moz-fit-content;\r\n    height: fit-content;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/create-login/create-login.component.css
// module id = ./src/app/login/create-login/create-login.component.css
// module chunks = main